<template>
  <v-dialog
    max-width="1680"
    :value="value"
    @input="closeModal"
    content-class="page-modal fixed-height-lg"
    @keydown.esc="closeModal"
  >
    <v-card class="pa-0">
      <v-card-text class="pa-0">
        <group-form
          :id="groupId"
          :triggerGroup="triggerGroup"
          :triggerOnly="triggerOnly"
          :groupFor="groupFor"
          :groupName="groupName"
          :meta="meta"
          :teamFilterOffProp="teamFilterOff"
          :contactFieldsOnly="contactFieldsOnly"
          isModal
          @groupSaved="$emit('groupSaved', $event)"
          @input="closeModal"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GroupForm from './GroupForm';
export default {
  name: 'GroupFormModal',
  components: {
    GroupForm,
  },
  props: {
    value: Boolean,
    groupId: String,
    groupFor: String,
    groupName: String,
    triggerGroup: {},
    triggerOnly: {},
    meta: {},
    teamFilterOff: Boolean,
    contactFieldsOnly: Boolean,
  },
  methods: {
    closeModal() {
      this.$emit('input', false);
    },
  },
};
</script>
